import { DocumentData } from "@angular/fire/firestore";
import { FormGroup } from "@angular/forms";
import { HoursOfOperation } from "../../hours.model";

enum DrinkExceptionState {
  None,
  Create,
  Edit,
  Duplicate
}
export class DrinkException {
  public hours: HoursOfOperation;
  public day: string;
  public type: number;
  public state: DrinkExceptionState;
  public price: number;

  constructor(day: string) {
    this.day = day;
    this.default();
  }

  compare(b: DrinkException): boolean {
    return (
      this.hours.begin == b.hours.begin &&
      this.hours.end == b.hours.end &&
      this.day == b.day &&
      this.type == b.type &&
      this.price == b.price
    );
  }

  default() {
    this.hours = new HoursOfOperation();
    this.type = 0;
    this.price = 0;
  }

  load(data: DocumentData) {
    this.hours = new HoursOfOperation().load(data.hours);
    this.type = data.type;
    this.price = data.price / 100;
    return this;
  }

  toJSON() {
    return {
      day: this.day,
      hours: this.hours.toJSON(),
      type: this.type,
      price: this.price * 100
    };
  }

  create(form: any) {
    this.hours = new HoursOfOperation().set(form.hours);
    this.price = form.price;
    this.type = form.type;
  }

  edit(drink: DrinkException) {
    this.hours = new HoursOfOperation().edit(drink.hours);
    this.type = drink.type;
    this.price = drink.price;
    return this;
  }

  public get isPriceChange(): boolean {
    return this.type == 0;
  }

  public timeframe(): string {
    return this.hours.toString();
  }
}
